import { useMeFavouritePartner } from '@capsicum/common';
import { useFollowedPartners } from '@capsicum/socios-core';

export const useMyTeamsBubbles = () => {
	const BASE_TEST_ID = 'my-teams-bubbles';
	const BUBBLE_SIZE = 60;
	const { favoritePartner } = useMeFavouritePartner();
	const { areFollowedTeamsLoading, followedPartners } = useFollowedPartners(favoritePartner?.id);

	return {
		areFollowedTeamsLoading,
		BASE_TEST_ID,
		BUBBLE_SIZE,
		favoritePartner,
		followedPartners
	};
};
